import { render, staticRenderFns } from "./ModuleIdeaVersioning.vue?vue&type=template&id=b827a014&"
import script from "./ModuleIdeaVersioning.vue?vue&type=script&lang=js&"
export * from "./ModuleIdeaVersioning.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIdeaVersioning.vue?vue&type=style&index=0&id=b827a014&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports